function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.00067 4.85118L5.00578 8.85622C5.09842 8.94893 5.22208 9 5.35393 9C5.48578 9 5.60944 8.94893 5.70207 8.85622L5.99702 8.56134C6.18895 8.3692 6.18895 8.05691 5.99702 7.86506L2.63383 4.50187L6.00075 1.13494C6.09339 1.04224 6.14453 0.918651 6.14453 0.786871C6.14453 0.654945 6.09339 0.531361 6.00075 0.438581L5.7058 0.143779C5.6131 0.0510721 5.48951 -5.72636e-08 5.35766 -6.87905e-08C5.22581 -8.03174e-08 5.10215 0.051072 5.00952 0.143779L1.00067 4.15248C0.907818 4.24548 0.856818 4.36965 0.857111 4.50165C0.856818 4.63416 0.907818 4.75825 1.00067 4.85118Z",
  fill: "#84CDBD"
});

var SvgMintleftarrow = function SvgMintleftarrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMintleftarrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mintleftarrow.c06245ef.svg";
export { ForwardRef as ReactComponent };